import * as React from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import SunriseSunsetSection from './SunriseSunsetSection';
import SourceTextSection from './SourceTextSection';

export type SunWidgetLabels = {
    source: string;
    infoMessage: string;
    notAvailable: string;
};

export interface IProps {
    sunrise: string;
    sunset: string;
    labels: SunWidgetLabels;
}

let WeatherWrapper = styled(Grid)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap'
}));

const SunWidget = ({ sunrise, sunset, labels }: IProps) => {
    let sourceLinkLabel = 'yr.no';

    let sourceUrl = 'https://www.yr.no/nb';

    return (
        <WeatherWrapper container>
            <SourceTextSection
                labels={labels}
                sourceLinkLabel={sourceLinkLabel}
                sourceUrl={sourceUrl}
            />
            <SunriseSunsetSection sunrise={sunrise} sunset={sunset} labels={labels} />
        </WeatherWrapper>
    );
};

export default SunWidget;
